import { CreateSubscriptionDto, SubscriptionInfo } from "../../services/api";

export interface CappedAmountWarningData {
  subscription: SubscriptionInfo;
}

export type CappedAmountWarningResult = CreateSubscriptionDto;

export interface CappedAmountOption {
  key: "suggested" | "double" | "triple";
  amount: number;
}

/** Only Enterprise negotiates its own cap; Growth and Advanced can only move to their plan's cap, if the API suggests a higher one. */
export const canRaiseCappedAmount = ({ type, cappedAmount, suggestedCappedAmount }: SubscriptionInfo): boolean =>
  type === SubscriptionInfo.TypeEnum.Enterprise || (!!suggestedCappedAmount && suggestedCappedAmount > cappedAmount);
